import script from "./CreateChatbotComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateChatbotComponent.vue?vue&type=script&setup=true&lang=js"

import "./CreateChatbotComponent.vue?vue&type=style&index=0&id=49c9e18e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49c9e18e"]])

export default __exports__